import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchWorkers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/workers/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchWorker(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/workers/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editWorker(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/workers", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteWorker(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/workers", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateWorkerSalary(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/workers/salary", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteWorkerSalary(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/workers/salary", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateWorkerDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/workers/document", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteWorkerDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/user_documents", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    downloadDocument(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/user_documents", {params: queryParams, responseType: "blob" })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    checkRegistrationCertificateNumber(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/check/registration_certificate_number", {params: queryParams})
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    checkSafetyTrainingCertificateNumber(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/check/safety_training_certificate_number", {params: queryParams})
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteClaimDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/claims/documents", {params: queryParams})
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
